import { render, staticRenderFns } from "./Webpush.vue?vue&type=template&id=d99983e6&scoped=true"
import script from "./Webpush.vue?vue&type=script&lang=js"
export * from "./Webpush.vue?vue&type=script&lang=js"
import style0 from "./Webpush.vue?vue&type=style&index=0&id=d99983e6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d99983e6",
  null
  
)

export default component.exports